import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getClientSuggestedServices = createAsyncThunk("client/sugessted-service-list", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/client/sugessted-service-list`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data.clientChildIssue);
    return res.data.providerServices;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch client suggested services");
  }
});

const clientSuggestedServicesSlice = createSlice({
    name: "clientSuggestedServices",
    initialState: {
      clientSuggestedServices: [],
      loading: false,
      error: null,
    },
    extraReducers: (builder) => {
          builder
            .addCase(getClientSuggestedServices.pending, (state) => {
                state.loading = true;
            })
            .addCase(getClientSuggestedServices.fulfilled, (state, action) => {
                state.clientSuggestedServices = action.payload;
                state.loading = false;
            })
            .addCase(getClientSuggestedServices.rejected, (state, action) => {
                state.error = action.payload || "Failed to fetch client suggested services"; 
                state.loading = false;
            })
             },
    });


export default clientSuggestedServicesSlice.reducer;